import ApplicationController from '../application_controller';

export default class Password extends ApplicationController {
  static targets = ['showButton', 'hideButton', 'passwordPattern'];

  static inputFieldState = null;

  initialize() {
    this.debouncedValidateOnInput = this.debounce(this.validateOnInput.bind(this), 300);
    this.debouncedValidateOnKeyup = this.debounce(this.validateOnKeyup.bind(this), 300);
  }

  connect() {
    this.inputField = this.element.querySelector('input[type="password"]');
  }

  togglePasswordInputType(event) {
    if (!this.inputField) return;

    const isPassword = this.inputField.type === 'password';
    event.currentTarget.classList.add('hidden');
    (isPassword ? this.hideButtonTarget : this.showButtonTarget).classList.remove('hidden');
    this.inputField.setAttribute('type', isPassword ? 'text' : 'password');
    this.inputField.focus();
  }

  validatePasswordEvent(stateOnValid, stateOnInvalid) {
    const passwordValue = this.inputField.value;
    this.validatePassword(passwordValue, (item, isValid) => {
      const state = isValid ? stateOnValid : stateOnInvalid;
      this.updateLabelState(item, state);
    });
  }

  // Captures input events including paste via mouse and keyboard
  validateOnInput() {
    if (this.inputFieldState) this.clearInputFieldState();
    this.validatePasswordEvent('success', 'clear');
  }

  // Captures events when the input field loses focus
  validateOnBlur() {
    this.validatePasswordEvent('success', 'error');
    this.updateInputFieldState();
  }

  // Captures backspace and delete keyup events
  validateOnKeyup(event) {
    if (event.key !== 'Backspace' && event.key !== 'Delete') return;
    if (this.inputFieldState) this.clearInputFieldState();
    this.validatePasswordEvent('success', 'clear');
  }

  validatePassword(passwordValue, callback) {
    if (!this.hasPasswordPatternTarget) return;

    this.passwordPatternTargets.forEach((item) => {
      const pattern = new RegExp(item.dataset.pattern),
            isValid = pattern.test(passwordValue);
      callback(item, isValid);
    });
  }

  updateLabelState(item, state) {
    const successIcon = item.querySelector('.tp-input-field-password-pattern__success-icon'),
          errorIcon = item.querySelector('.tp-input-field-password-pattern__error-icon'),
          successLabelClass = 'tp-input-field-password-pattern__item--success',
          errorLabelClass = 'tp-input-field-password-pattern__item--error';

    if (state === 'success') {
      item.classList.add(successLabelClass);
      item.classList.remove(errorLabelClass);
      successIcon.classList.remove('hidden');
      errorIcon.classList.add('hidden');
    } else if (state === 'error') {
      item.classList.add(errorLabelClass);
      item.classList.remove(successLabelClass);
      errorIcon.classList.remove('hidden');
      successIcon.classList.add('hidden');
    } else if (state === 'clear') {
      item.classList.remove(successLabelClass);
      item.classList.remove(errorLabelClass);
      successIcon.classList.add('hidden');
      errorIcon.classList.remove('hidden');
    }
  }

  updateInputFieldState() {
    if (!this.hasPasswordPatternTarget) return;

    const successClass = 'tp-input-field--text-success',
          errorClass = 'tp-input-field--text-error';

    const isValid = this.passwordPatternTargets.every(item => item.classList.contains('tp-input-field-password-pattern__item--success'));
    const isError = this.passwordPatternTargets.some(item => item.classList.contains('tp-input-field-password-pattern__item--error'));

    if (isValid) {
      this.element.classList.add(successClass);
      this.element.classList.remove(errorClass);
      this.inputFieldState = 'success';
    } else if (isError) {
      this.element.classList.add(errorClass);
      this.element.classList.remove(successClass);
      this.inputFieldState = 'error';
    }
  }

  clearInputFieldState() {
    const successClass = 'tp-input-field--text-success',
          errorClass = 'tp-input-field--text-error';

    this.element.classList.remove(successClass);
    this.element.classList.remove(errorClass);
    this.inputFieldState = null;
  }

  debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
}
